import React from 'react'
import { useIntl } from 'react-intl'
import { InformationPanel } from '@contrast-security-inc/design-system-surfaces'

export const ErrorInformationPanel = ({ error }) => {
  const intl = useIntl()

  return (
    <InformationPanel
      detail={intl.formatMessage({ id: 'detail_dependencyTreeError' })}
      testId="error"
    >
      {error.message}
    </InformationPanel>
  )
}
